var pdp_product_row_organic = document.querySelectorAll(".is_organic");
var pdp_product_row_inorganic = document.querySelectorAll(".not_organic");
var pdp_product_row_grassprotect = document.querySelectorAll(".grass_protect");

document.addEventListener("DOMContentLoaded", function (event) {
  document
    .querySelector(".active_dynamic_row .target_grass_protect")
    ?.classList.add("grass_protect");
});

var buyboxprice = document.querySelector(
  ".pdp-buy-box .product__price-container",
);

function initAnimation() {
  $(buyboxprice).addClass("loading");

  if ($(buyboxprice).length > 0) {
    setTimeout(function () {
      $("#js-loading-page").fadeOut(300);
      $(buyboxprice).removeClass("loading");
    }, 800);
  }
}

function check_organic() {
  if (window.isOrganic) {
    hide_inorganic();
    // hide_grassprotect()
    show_organic();
    const input = document.querySelector(
      ".organic-selection input[name='Organic'][value='Bio']",
    );
    if ($(input).length > 0) {
      const clickEvent = new MouseEvent("click", { button: 0, which: 1 });
      input.dispatchEvent(clickEvent);
    }

    initAnimation();
  } else {
    hide_organic();
    show_inorganic();
    initAnimation();
  }

  if (window.isGrassProtect) {
    show_grassprotect();
    initAnimation();
  } else {
    hide_grassprotect();
  }
}

function show_organic() {
  document.body.classList.add("show_organic");

  pdp_product_row_organic.forEach((item) => {
    item.setAttribute("style", "display:inline-flex");
  });
}

function show_inorganic() {
  document.body.classList.add("show_inorganic");
  pdp_product_row_inorganic.forEach((item) => {
    item.setAttribute("style", "display:inline-flex");
  });
}
function show_grassprotect() {
  $(".grass_protect").each(function () {
    if (!$(this).closest(".active_dynamic_row").length) {
      $(this).removeClass("grass_protect");
    }
  });

  document.body.classList.add("show_grassprotect");
  //  pdp_product_row_grassprotect.forEach((item) => {
  //   item.setAttribute("style", "display:inline-flex !important");
  // });

  pdp_product_row_grassprotect.forEach(function (item) {
    item.setAttribute("style", "display:inline-flex !important");
  });
}
function hide_organic() {
  document.body.classList.remove("show_organic");
  pdp_product_row_organic.forEach((item) => {
    item.setAttribute("style", "display:none !important");
  });
}
function hide_inorganic() {
  document.body.classList.remove("show_inorganic");
  pdp_product_row_inorganic.forEach((item) => {
    item.setAttribute("style", "display:none !important");
  });
}
function hide_grassprotect() {
  document.body.classList.remove("show_grassprotect");
  pdp_product_row_grassprotect.forEach((item) => {
    item.setAttribute("style", "display:none !important");
  });
}

console.log("running session script");
check_organic();
// window.addEventListener('load', function() {
//           check_organic();
// });
